/*
 * @Author: Zhouqi
 * @Date: 2026-03-26 13:45:17
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-03-26 13:45:44
 */
import request from '@/utils/request';

export enum ACTIVITY_USER_TYPE {
  FREE_USER = 4, // 免费用户，可参与活动
}

export const activityCode = 'MAR_activity';

interface IUserActivityResponse {
  code: number;
  data: {
    activityUserType: number;
    userTypeExpireTime: number; // 毫秒时间戳
  };
}

export const getUserActivity = async (
  activityCode: string,
): Promise<IUserActivityResponse> => {
  const res = await request('/api/rest/dlt/user/activity', {
    method: 'POST',
    data: { activityCode },
  });
  return res;
};
